
(function(angular) {
	'use strict';
	/**
	 * navigation module
	 */
	var navigation = angular.module('Core');

	navigation.service('NavigationService', ['$log', '$rootScope', '$timeout', '$location', '$window',
		'NotificationService', 'LocalStorageService', '$translate', 'ModalService',
		function($log, $rootScope, $timeout, $location, $window, NotificationService, LocalStorageService, $translate, ModalService) {

			this.MAX_OPEN_TABS = 8;
			this.LOCAL_STORAGE_KEY = 'LS_MAIN_TABS';

			this.crtTabId = 0;
			this.tabs = [];
			this.activeTab = null;

			this.navEnabled = true;

			var service = this;
			var historicTab = [];
			var lastActivatedTab;

			var hiddenTab = null;

			/**
			 * Change the active status of all tab to "not active"
			 */
			var deactiveAllTabs = function() {
				var all = service.tabs;
				for (var i = 0; i < all.length; i++) {
					if (all[i].active === true) {
						lastActivatedTab = all[i];
					}
					all[i].active = false;
				}
			};

			/*
			 * Search a tab for a url
			 * @param {String} url Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTab = function(url) {
				if (url.charAt(url.length - 1) === '/') {
					url = url.substring(0, url.length - 1);
				}
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					var urlB = tab.tabUrl;
					if (urlB.charAt(urlB.length - 1) === '/') {
						urlB = urlB.substring(0, urlB.length - 1);
					}
					if (urlB === url) {
						return tab;
					}
				}
				return null;
			};

			/*
			 * Search a tab for a url
			 * @param {String} url Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTabByUrlContains = function(url) {
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tabUrl.indexOf(url) > -1) {
						return tab;
					}
				}
				return null;
			};

			/**
			 * Will look in the tabs to activate the right tab
			 */
			var updateActiveTab = function() {
				var currentUrl = $location.absUrl();
				if (currentUrl !== null) {
					var spl = currentUrl.split('#');
					if (spl.length > 1) {
						spl = spl[1].split('?');
						currentUrl = spl[0];
					} else {
						currentUrl = '/';
					}
				}

				deactiveAllTabs();
				var tab = searchTab(currentUrl);
				if (tab !== null) {
					historicTab.push(tab);
					tab.active = true;
					service.activeTab = tab;
					$log.debug('NavigationService: Tab with url [' + tab.tabUrl + '] is now active.');
				}
			};

			/*
			 * Search a tab by his id
			 * @param {int} id Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTabById = function(id) {
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tabId === id) {
						return tab;
					}
				}
				return null;
			};

			/**
			 *
			 * @param {Tab} tabSrc the src
			 * @param {Tab} tabTarget the destination of the copy
			 * @returns {Tab} the destination tab
			 */
			var copyTabConfiguration = function(tabSrc, tabTarget) {
				if (tabSrc !== null && tabTarget !== null) {
					if (tabSrc.tabUrl) {
						tabTarget.tabUrl = tabSrc.tabUrl;
					}
					if (tabSrc.iconUrl) {
						tabTarget.iconUrl = tabSrc.iconUrl;
					}
					if (tabSrc.text) {
						tabTarget.text = tabSrc.text;
					}
					if (tabSrc.closeable) {
						tabTarget.closeable = tabSrc.closeable;
					}
					if (tabSrc.dirty !== undefined) {
						tabTarget.dirty = tabSrc.dirty;
					}
					if (tabSrc.loading !== undefined && tabSrc.loading !== null) {
						tabTarget.loading = tabSrc.loading;
					}

					if (tabSrc.configuration !== undefined && tabSrc.configuration !== null) {
						tabTarget.configuration = tabSrc.configuration;
					}

					if (tabSrc.transient !== undefined && tabSrc.transient !== null) {
						tabTarget.transient = tabSrc.transient;
					}

					if (tabSrc.initParams !== undefined && tabSrc.initParams !== null) {
						tabTarget.initParams = tabSrc.initParams;
					}

					if (tabSrc.hidden !== undefined) {
						tabTarget.hidden = tabSrc.hidden;
					}
				}
				return tabTarget;
			};

			var getActiveTab = function() {
				for (var i = 0; i < service.tabs.length; i++) {
					var tab = service.tabs[i];
					if (tab.active) {
						return tab;
					}
				}
				return null;
			};

			var checkNavEnabled = function() {
				if (!service.navEnabled) {
					var title = $translate.instant('navigation.navDisabledTitle');
					var msg = $translate.instant('navigation.navDisabled');
					NotificationService.notify('INFO', title, msg);
					return false;
				}
				return true;
			};

			$rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
				if (service.navEnabled) {
					updateActiveTab();
					$rootScope.$broadcast('navigation-update');
				} else {
					event.preventDefault();
					if (!checkNavEnabled()) {
						$log.info('NavigationService: Could not change route location. Navigation is disabled.');
					}
				}
				return;
			});

			/* Update the localstorage with the tabs */
			var updateStorage = function() {
				var storageTabs = [];
				for (var i = 0; i < service.tabs.length; i++) {
					var t = service.tabs[i];
					if (!(t.transient === true)) {
						storageTabs.push(t);
					}
				}
				LocalStorageService.setValue(service.LOCAL_STORAGE_KEY, storageTabs);
			};

			var loadStorage = function() {
				if (LocalStorageService.isValueSet(service.LOCAL_STORAGE_KEY)) {
					$log.debug('NavigationService: Loading tabs from the local storage...');

					var lsTabs = LocalStorageService.getValue(service.LOCAL_STORAGE_KEY);
					var newTabs = [];
					for (var i = 0; i < lsTabs.length && i < service.MAX_OPEN_TABS; i++) {
						var tab = {};
						service.crtTabId++;
						tab.tabId = service.crtTabId;
						copyTabConfiguration(lsTabs[i], tab);
						tab.hidden = false;
						tab.dirty = false;
						newTabs.push(tab);
						$log.debug('NavigationService: Tabs with url "' + tab.tabUrl + '" loaded from local storage.');
					}


					// we look if we have to close the current tab
					var activeTab = getActiveTab();
					if (activeTab !== null) {

						if (activeTab.transient === true) {
							newTabs.push(activeTab);
							$log.debug('NavigationService: Current active tab is transient. We don\'t change the location.');
						} else {
							var url = activeTab.tabUrl;
							var found = false;
							for (var j = 0; j < newTabs.length; j++) {
								if (newTabs[j].tabUrl === url) {
									found = true;
								}
							}
							if (!found) {
								// Change page...
								// but re-enable navigation before...
								service.enableNavigation();
								$location.path('/');
							}
						}
					}
					service.tabs = newTabs;



					updateActiveTab();

					$rootScope.$broadcast('navigation-update');

					$log.debug('NavigationService: Tabs loaded with success from local storage.');
				} else {
					$log.debug('NavigationService: No tabs found in local storage.');
				}
			};



			var changeLocation = function(url) {
				$timeout(function() {
					$location.path(url);
				});
			};

			var openLastTab = function() {
				while (historicTab.length > 0) {
					var tab = historicTab.pop();
					if (searchTabById(tab.tabId) !== null) {
						changeLocation(tab.tabUrl);
						return;
					}
				}
				$location.path('/');
			};

			var getTabPosition = function(tabId) {
				for (var i = 0; i < service.tabs.length; i++) {
					if (service.tabs[i].tabId === tabId) {
						return i;
					}
				}
				return null;
			};

			var removeHiddenTab = function() {
				if (hiddenTab !== null) {
					searchTabById(hiddenTab);
					var position = getTabPosition(hiddenTab.tabId);
					if (position !== null) {
						service.tabs.splice(position, 1);
						updateStorage();
					}
					hiddenTab = null;
				}
			};

			/**
			 * Open a new tab. If the url is already present in the tabs list, the tab is not opened !
			 * @param {Tab} tab:
			 * {
			 *	tabUrl: The url to use in the tab
			 *	text: The text inside the tab
			 *	iconUrl: A link to an icon (24x24px)
			 *	closeable: true to use a closeable tab
			 *	loading: true to display the ajax loader / false to hide
			 *	transient: true to create a transient tab. When true, the tab is not stored to local storage (default false)
			 *	initParams: Data to pass to the tab to open (default null)
			 * }
			 * @param {Options} options
			 * {
			 *	activateTab: use true to directly open the url defined in the tab
			 * }
			 * @returns the tab created or already present tab
			 */
			this.openTab = function(tab, options) {
				var openedTab = searchTab(tab.tabUrl);
				if (openedTab === null) {
					if (!checkNavEnabled()) {
						$log.info('NavigationService: Navigation is disabled. The tab will not be opened !');
					} else {
						$log.debug('NavigationService: Opening tab with url [' + tab.tabUrl + ']...');
						openedTab = tab;
						this.crtTabId++;
						tab.tabId = this.crtTabId;
						this.tabs.push(tab);
						removeHiddenTab();
						if (this.openTabsSize() > this.MAX_OPEN_TABS) {
							var title = $translate.instant('navigation.tabsLimitTitle');
							var msg = $translate.instant('navigation.tabsLimit');
							NotificationService.notify('INFO', title, msg);
							$log.info('NavigationService: Number of opened tabs limit reached. The tab will not be opened !');
							service.activeTab = null;
							hiddenTab = tab;
							tab.hidden = true;
						}

						updateActiveTab();
						updateStorage();
						$rootScope.$broadcast('navigation-update');
						$log.debug('NavigationService: Tab with url [' + tab.tabUrl + '] opened.');


					}
				} else {
					// Let's update the tab...
					updateActiveTab();
					this.updateTab(openedTab.tabId, tab);
				}

				if (options && options.activateTab && openedTab) {
					$log.debug('NavigationService: Moving location to [' + openedTab.tabUrl + '].');
					changeLocation(openedTab.tabUrl);
				}

				return openedTab;
			};

			/**
			 * get the number of open tabs
			 * @returns {int} number of open tabs
			 */
			this.openTabsSize = function() {
				return this.tabs.length;
			};

			/**
			 * Activate a new tab from the list
			 * @param {int} tabId
			 */
			this.activateTab = function(tabId) {
				if (!checkNavEnabled()) {
					$log.info('NavigationService: Could not activate tab with id ' + tabId + '. Navigation is disabled.');
					return;
				}
				var tab = searchTabById(tabId);
				if (tab !== null) {
					changeLocation(tab.tabUrl);
				} else {
					$log.error('NavigationService: Could not activate tab with id ' + tabId + '. The tab doesn\'t exist.');
				}
			};

			/**
			 * Close a tab by his id
			 * @param {int} tabId the tab id (optional: when null the current tab is closed)
			 */
			this.closeTab = function(tabId, move) {
				var mustMove = true;
				if (move === false) {
					mustMove = false;
				}
				var tid = tabId;
				if ((tid === undefined || tid === null) && service.activeTab) {
					tid = service.activeTab.tabId;
				}
				var found = false;
				for (var i = 0; i < this.tabs.length; i++) {
					if (this.tabs[i].tabId === tid) {
						var tab = this.tabs[i];
						var confirmFn = function() {
							service.tabs.splice(i, 1);
							$log.debug('NavigationService: Tab with id [' + tab.tabId + '] has been closed.');
							$rootScope.$broadcast('navigation-update');
							updateStorage();

							if (tab.active) {
								service.enableNavigation();

								if (mustMove === true) {
									// let's move to /
									$timeout(function() {
										$log.debug('NavigationService: Tab with id [' + tab.tabId + '] was active. Moving user to /.');
										openLastTab();

									});
								}
							} else if (hiddenTab !== null && service.openTabsSize() <= service.MAX_OPEN_TABS) {
								hiddenTab.hidden = false;
								hiddenTab = null;
							}
						};

						if (tab.closeable === true) {
							if (!tab.dirty) {
								confirmFn();
							} else {
								// User must confirm !
								ModalService.confirmationModal({
									modalTitle: $translate.instant('navigation.fermerTabTitre'),
									modalText: $translate.instant('navigation.fermerTabMessage')
								}, confirmFn);
							}
						} else {
							$log.warn('NavigationService: Tab with id [' + tab.tabId + '] is not closeable ! The tab will not be closed.');
						}

						found = true;
						break;
					}
				}
				if (!found) {
					$log.error('NavigationService: Could not close tab with id ' + tabId + '. The tab was not found.');
				}
			};

			this.closeErrorTab = function() {
				var tid = service.activeTab.tabId;
				this.closeTab(tid, false);
			};

			/**
			 * get the currently opened tab
			 * @returns {Tab} the currently opened tab
			 */
			this.getActiveTab = function() {
				return getActiveTab();
			};

			/**
			 * Update an existing tab
			 * @param {type} tabId the tab identifiant
			 * @param {type} config the tab configuration
			 */
			this.updateTab = function(tabId, config) {
				// First we get the tab by his id...
				var crtTab = searchTabById(tabId);

				// If url is the same than another tab, we close the current tab
				var tabUrl = this.getTabByUrl(config.tabUrl);
				if (tabUrl && tabUrl.tabId !== tabId) {
					crtTab = tabUrl;
					this.closeTab(tabId, false);
				}

				if (crtTab !== null) {
					copyTabConfiguration(config, crtTab);
					updateStorage();
					$rootScope.$broadcast('navigation-update');
				} else {
					$log.error('NavigationService: Could not find tab with id ' + tabId + '.');
				}
			};

			/**
			 * Get a tab by url
			 * @param {String} url the url to search
			 * @returns {Tab} the tab found
			 */
			this.getTabByUrl = function(url) {
				return searchTab(url);
			};

			/**
			 * Get a tab by url contains
			 * @param {String} url the url to search
			 * @returns {Tab} the tab found
			 */
			this.getTabByUrlContains = function(url) {
				return searchTabByUrlContains(url);
			};

			/**
			 * Load a list of tabs
			 * @param {Tab[]} tabs
			 */
			this.loadTabs = function(tabs) {
				if (tabs !== null) {
					for (var i = 0; i < tabs.length; i++) {
						service.openTab(tabs[i]);
					}
				}
			};

			/**
			 * Get the full list of opened tabs
			 * @returns {Array} the tabs
			 */
			this.getTabs = function() {
				return service.tabs;
			};

			/**
			 * Look in each tab if at least one is dirty. In that case we return true.
			 * @returns {boolean} true if at least 1 tab is dirty
			 */
			this.isDirty = function() {
				for (var i = 0; i < this.tabs.length; i++) {
					var t = this.tabs[i];
					if (t.dirty) {
						return true;
					}
				}
				return false;
			};

			this.clearDirtyStates = function() {
				for (var i = 0; i < this.tabs.length; i++) {
					var t = this.tabs[i];
					t.dirty = false;
				}
			};

			this.tabData = {};


			var getTabUrlOrCrt = function(tabUrl) {
				var url = tabUrl;
				if (url === undefined || url === null) {
					url = $location.path();
				}
				return url;
			};

			/**
			 * Get the tab configuration from url
			 * (if tabUrl is undefined the function attempt to retrive the current tab configuration).
			 * @param {String|undefined} tabUrl The tab URL
			 * @returns {Object|null} the configuration
			 */
			this.getTabConfiguration = function(tabUrl) {
				var tab = searchTab(getTabUrlOrCrt(tabUrl));

				if (tab === null) {
					return null;
				}
				return tab.configuration;
			};

			/**
			 * Set the tab configuration for the passed url
			 * (if tabUrl is undefined the function set the passed configuration to the current tab).
			 * @param {Obejct} configuration The configuration to save for the selected tab
			 * @param {String|undefined} tabUrl
			 * @returns {void}
			 */
			this.setTabConfiguration = function(configuration, tabUrl) {
				var tab = searchTab(getTabUrlOrCrt(tabUrl));

				if (tab === null) {
					return;
				}
				tab.configuration = configuration;
				updateStorage();
			};

			/**
			 * Store data in the navigation for a desired tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @param {Object} data data to save
			 */
			this.saveTabData = function(data, tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				this.tabData[url] = data;
				$log.debug('NavigationService: Data stored for url ' + url);
			};

			/**
			 * Returns true if data are saved in this tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @returns {boolean} true if data are saved in this tab
			 */
			this.hasTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				return this.tabData[url] !== undefined && this.tabData[url] !== null;
			};

			/**
			 * Returns te data associated to the tab url
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @returns {Object} the data stored in the tab
			 */
			this.getTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				var data = null;
				if (this.hasTabData()) {
					data = this.tabData[url];
				}
				return data;
			};

			/**
			 * Clear the data sored in a tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 */
			this.clearTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				this.tabData[url] = null;
				$log.debug('NavigationService: Data cleared for url ' + url);
			};

			/**
			 * Disable the $route
			 */
			this.disableNavigation = function() {
				this.navEnabled = false;
				$rootScope.$broadcast('navigation-enabled', this.navEnabled);
				$log.debug('NavigationService: navigation disabled.');
			};
			/**
			 * Disable the $route
			 */
			this.enableNavigation = function() {
				this.navEnabled = true;
				$rootScope.$broadcast('navigation-enabled', this.navEnabled);
				$log.debug('NavigationService: navigation enabled.');
			};

			/**
			 * @returns {boolean} true when nav is enabled
			 */
			this.isNavigationEnabled = function() {
				return this.navEnabled;
			};


			this.init = function() {
				loadStorage();
				// add a tracker to the localstorage.
				LocalStorageService.registerValueTracker(this.LOCAL_STORAGE_KEY, function() {
					loadStorage();
				});
			};

			/**
			 * Hide the tabs
			 */
			this.hideNavigation = function() {
				$rootScope.$broadcast('navigation-hidden');
			};

			/**
			 * re enable nav and set the path
			 * @param {String} path the path to use (optional)
			 */
			this.forcePath = function(path) {
				this.enableNavigation();
				this.clearDirtyStates();
				if (path) {
					$timeout(function() {
						$location.path(path);
					});
				}
			};



			// Window close detection
			$window.onbeforeunload = function() {
				if (service.isDirty()) {
					return $translate.instant('navigation.fermerFenetre');
				}
			};
		}]);
})(angular);
